import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";
import { formatHuf, lineTotals, offerTotals } from "@/utils/offerTotals";

export type OfferTableProps = {
  items: any[];
};

const sortable = false;
const fixed = true;

export default /*#__PURE__*/_defineComponent({
  __name: 'AddOfferTable',
  props: {
    items: {}
  },
  emits: ["remove-item", "edit-item"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

const emit = __emit;

const props = __props;
const headers = [
  {
    title: "Szálláshely",
    sortable,
    fixed,
    align: "start",
    key: "accommodation",
  },
  { title: "Termék", sortable, fixed, key: "product" },
  { title: "Időszak", sortable, fixed, key: "period" },
  { title: "Fő", sortable, fixed, key: "numberOfPeople", align: "end" },
  {
    title: "Bejövő bruttó /fő/éj",
    sortable,
    fixed,
    key: "grossPricePerPersonPerNight",
    align: "end",
  },
  {
    title: "Kimenő nettó /fő/éj",
    sortable,
    fixed,
    key: "retailPrice",
    align: "end",
  },
  {
    title: "Árrés /fő/éj",
    sortable,
    fixed,
    key: "marginPerPersonPerNight",
    align: "end",
  },
  { title: "Tétel összesen", sortable, fixed, key: "revenue", align: "end" },
  { title: "", sortable, fixed, key: "actions", align: "end" },
];

const rows = computed(() =>
  props.items.map((item, index) => ({
    ...item,
    ...lineTotals(item),
    index,
  }))
);

const totals = computed(() => offerTotals(props.items));

const removeItem = (index: number) => {
  emit("remove-item", index);
};

const editItem = (index: number) => {
  emit("edit-item", index);
};

const __returned__ = { emit, props, sortable, fixed, headers, rows, totals, removeItem, editItem, computed, get formatHuf() { return formatHuf }, get lineTotals() { return lineTotals }, get offerTotals() { return offerTotals } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})